import { useCallback } from 'react'
import api from '../../lib/commons/api'
import { TicketListRepository } from '../../applications/ports/ticketListRepository'
import { ReferencedEntity } from '../../domain/value-object/ReferencedEntity'

export const useTicketListRepository = (): TicketListRepository => {
  const fetchListAsReferencedEntity = useCallback(
    async (projectUuid: string, ticketType?: string) => {
      const response = await api.functional.request(
        'GET',
        '/api/v1/projects/ticket_lists/list',
        { projectUuid, ticketType },
        true
      )
      return response.json.map(res => ({
        uuid: res.uuid,
        name: res.wbsItem.displayName,
        ticketType: res.ticketType,
        status: res.wbsItem.status,
      }))
    },
    []
  )
  const fetchAsReferencedEntity = useCallback(
    async (uuid: string): Promise<ReferencedEntity | undefined> => {
      const response = await api.functional.request(
        'GET',
        '/api/v1/projects/ticket_lists/referenced_values',
        { uuid },
        true
      )
      const ticketList = response.json
      return ticketList
        ? {
            uuid: ticketList.uuid,
            name: ticketList.name,
          }
        : undefined
    },
    []
  )
  return {
    fetchListAsReferencedEntity,
    fetchAsReferencedEntity,
  }
}
